<template>
  <div class="nat-user-building">
    <div class="nat-user-building-tips">
      您还未在本院建卡，建卡后自动跳转预约界面！
    </div>
    <van-form @submit="onSubmit" class="nat-user-building-form">
      <van-field
        v-model="name"
        :rules="[
          {
            required: true,
            message: '请填写姓名'
          }
        ]"
        name="name"
        placeholder="请填写姓名"
        label="姓名"
        readonly
      />
      <van-field
        v-model="idCard"
        :rules="[
          {
            required: true,
            message: '请填写证件号'
          }
        ]"
        name="idCard"
        placeholder="请填写证件号"
        label="证件号"
        readonly
      />
      <van-field
        v-model="phone"
        :rules="[
          {
            required: true,
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: '请填写正确的手机号'
          }
        ]"
        name="phone"
        type="number"
        placeholder="请填写手机号"
        label="手机号"
      />
      <van-field
        v-model="sex"
        :rules="[
          {
            required: true,
            message: '请选择性别'
          }
        ]"
        @click="showPickerSex = true"
        name="sex"
        placeholder="请选择性别"
        label="性别"
        readonly
      />
      <van-field
        v-model="birthday"
        :rules="[
          {
            required: true,
            message: '请选择出生年月'
          }
        ]"
        name="birthday"
        placeholder="请选择出生年月"
        label="出生年月"
        readonly
      />
      <van-field
        v-model="address"
        :rules="[
          {
            required: true,
            message: '请填写家庭住址'
          }
        ]"
        name="address"
        placeholder="请填写家庭住址"
        label="家庭住址"
      />
      <ph-button
        class="nat-user-building-button"
        title="下一步"
        native-type="submit"
      />
    </van-form>
    <van-popup v-model="showPickerSex" position="bottom">
      <van-picker
        :columns="sexList"
        @confirm="sexConfirm"
        @cancel="showPickerSex = false"
        show-toolbar
      />
    </van-popup>
    <van-popup v-model="showPickerBirthday" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        :min-date="minDate"
        @confirm="birthdayConfirm"
        @cancel="showPickerBirthday = false"
        type="date"
        show-toolbar
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      openId: "",
      name: "",
      idCard: "",
      phone: "",
      sex: "",
      birthday: "",
      address: "",
      currentDate: new Date(),
      minDate: new Date(1900, 0, 1),
      showPickerSex: false,
      showPickerBirthday: false,
      sexList: ["男", "女"]
    };
  },
  created() {
    const { query } = this.$route;
    this.name = query.name;
    this.idCard = query.idCard;
    this.phone = query.phone;
    this.openId = query.openId;
    this.getbirthday(this.idCard);
  },
  methods: {
    onSubmit(value) {
      this.$http.post(this.$api.TEST_CREAT_FILE, value).then(() => {
        this.$router.push({
          name: "nucleic-acid-test-nat",
          query: {
            openId: this.openId,
            name: value.name,
            idCard: value.idCard
          }
        });
        // const path = `./pay.html?openId=${this.openId}&name=${value.name}&idCard=${value.idCard}`;
        // window.location.href = path;
      });
    },
    getbirthday(idCard) {
      var birthday = "";

      if (idCard != null && idCard != "") {
        if (idCard.length == 15) {
          birthday = "19" + idCard.slice(6, 12);
        } else if (idCard.length == 18) {
          birthday = idCard.slice(6, 14);
        }
        this.birthday = birthday;
        //通过正则表达式来指定输出格式为:1990-01-01
      }
    },
    sexConfirm(value) {
      this.sex = value;
      this.showPickerSex = false;
    },
    birthdayConfirm(value) {
      this.birthday = this.$moment(value).format("YYYYMMDD");
      this.showPickerBirthday = false;
    }
  }
};
</script>

<style lang="less">
.nat-user-building {
  &-tips {
    padding: 0.4rem 0;
    color: white;
    font-size: 0.9rem;
    text-align: center;
    background: @primary-blue;
  }
  &-form {
    padding: 0.8rem;
    background: white;

    .van-cell {
      padding: 0.6rem 0;
      border-bottom: 1px solid @primary-gray;
      input::-webkit-input-placeholder {
        color: gray;
      }
    }

    .van-cell::after {
      position: relative;
    }

    .van-field__body {
      font-size: 0.94rem;
    }
  }

  &-button {
    margin-top: 1rem;
  }
}
</style>
